import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const DrumCellEm = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const DrumCellText = styled.span`
  font-size: ${tokens.font.body};
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
`

export const DrumFloatValue = styled.span<{ $open?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: ${({ $open }) => ($open ? tokens.status.warning.fg : tokens.text.secondary)};
`

export const DrumCellStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`

export const DrumCellNote = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const DrumSummaryLine = styled.p`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.status.warning.fg};
  font-variant-numeric: tabular-nums;
`
